module.exports = __webpack_public_path__ + "img/only-leftwindow.a72b6c9a.svg";